/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import { inject as service } from '@ember/service';
import { action, setProperties } from '@ember/object';
import EnvironmentService from 'cio/services/environment';
import RelationshipCondition from 'cio/app-models/conditions/relationship';
import ObjectTypesService from 'cio/services/object-types';

interface ConditionEditorRelationshipNameArgs {
  condition: RelationshipCondition;
  disabled: boolean;
  size?: string;
}

export default class ConditionEditorRelationshipName extends Component<ConditionEditorRelationshipNameArgs> {
  @service environment!: EnvironmentService;
  @service objectTypes!: ObjectTypesService;

  @action
  onTypeChange(value: string) {
    this.args.condition.setProperties({ typeId: value });
    this.args.condition.filters.forEach((filter) => {
      setProperties(filter, {
        objectTypeId: value,
        operator: 'eq',
        name: '',
        comparisonOperator: 'value',
        value: '',
      });
      filter.createEditCopy();
    });
  }

  get objectTypesOptions() {
    return this.objectTypes.enabledObjectTypes.map((objectType) => ({
      label: objectType.name,
      value: objectType.id,
    }));
  }
}
